import { render } from "./projectStatusesPairs.vue?vue&type=template&id=761a70b4&ts=true"
import script from "./projectStatusesPairs.vue?vue&type=script&lang=ts"
export * from "./projectStatusesPairs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__